import React, { Component } from "react";

import schema from "./schema";
import datalink from "./datalink";
import { Box, Typography } from "@mui/material";

import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { Accessor, ColorX, Authority } from "static";

class Intent extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      title: "INTENTS",
      serverSidePagination: false,
      base: {
        title: "INTENTS",
        exportDoc: "Intents",
        schema: schema,
        reqAuth: "Workspace.Intent",

        tablizo: {
          showSelector: true,
          columnsToolbar: true,
          filterToolbar: true,
          densityToolbar: true,
          exportToolbar: false,
        },

        Connect: {
          DBInfo: datalink.Request.DBInfo,
          List: datalink.Request.List,
          schema: schema.Table,
        },

        operations: {
          Add: {
            title: "Add Intent",
            url: datalink.Request.Add,
            success: "Intent Added Successfully",
            fail: "Intent Add Failed: ",
            schema: schema.Add,
            buttons: ["Clear", "Submit"],
            onSubmit: "Add",
          },
          Delete: {
            title: "Delete this Intent?",
            content: "Caution: This is irrevertable.",
            url: datalink.Request.Delete,
            success: "Intent Deleted Successfully.",
            fail: "Intent Delete Failed: ",
            onSubmit: "Delete",
          },
          Edit: {
            title: "Edit Intent ",
            url: datalink.Request.Edit,
            success: "Intent Edited Successfully",
            fail: "Intent Edit Failed: ",
            schema: schema.Edit,
            buttons: ["Revert", "Submit"],
            onSubmit: "Edit",
          },
          Info: {
            title: "Intent ",
            url: datalink.Request.Info,
            success: "Intent Load Successfully",
            fail: "Intent Load Failed: ",
            schema: schema.Info,
            readOnly: true,
          },
          Sync: {
            title: "Sync from NLP",
            content: "Caution: This is irrevertable.",
            url: datalink.Request.Sync,
            success: "Intent Sync Successfully.",
            fail: "Intent Sync Failed: ",
            onSubmit: "Sync",
          },
          DeleteBulk: {
            title: (n) => "Delete these " + n + " Intents?",
            content: "Caution: This is irrevertable.",
            url: datalink.Request.DeleteBulk,
            success: "Intents Deleted Successfully.",
            fail: "Intents Delete Failed: ",
            onSubmit: "DeleteBulk",
          },
        },

        buttons: {
          inline: [
            { icon: "edit", func: "Edit", caption: "Edit", reqFunc: "Edit" },
            { icon: "info", func: "Info", caption: "Details" },
            { icon: "delete", func: "Delete", caption: "Delete", reqFunc: "Delete" },
          ],
          left: [{ icon: "add", func: "Add", caption: "Add Intent", reqFunc: "Add" }],
          right: [
            { icon: "deletebulk", func: "DeleteBulk", caption: (n) => "Delete (" + n + ")", reqFunc: "Delete", theme: "caution" },
            { icon: "export", func: "Export", caption: (n) => "Export (" + (n === 0 ? "All" : n) + ")", reqFunc: "Export" },
            { icon: "import", func: "Import", caption: "Import", reqFunc: "Import" },
            { icon: "syncfrom", func: "Sync", caption: "Sync", reqFunc: "Sync" },
          ],
        },
      },
    };
  }

  componentDidMount() {
    Authority.Require("Workspace.Intent");
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(Intent.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  onMountDatumizo = (callbacks) => {
    this.MountDatumizo = callbacks;
  };

  render() {
    let { base, serverSidePagination, title } = this.state;
    return (
      <VStack>
        <Box padding={1} width="100%">
          <Typography
            style={{
              textAlign: "left",
              width: "100%",
              fontSize: 25,
              color: ColorX.GetColorCSS("Primary"),
            }}
          >
            {title}
          </Typography>
        </Box>
        <Datumizo
          base={base}
          serverSidePagination={serverSidePagination}
          onMounted={this.onMountDatumizo}
          addOns={{
            workspace: "master",
            allIntents: true,
          }}
        />
      </VStack>
    );
  }
}

export default Intent;
